module.exports = __webpack_public_path__ + "img/icon-checkbox-checked.e3656ea2.svg";